import React from "react";
import styles from "./styles.module.css";

export function Badge({
  children,
  variant = "default",
  className = "",
  ...props
}) {
  return (
    <span
      className={`${styles.badge} ${styles[variant] || ""} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
